import { Box, Spinner } from '../../../primitives'

export const CenteredSpinner = () => {
  return (
    <Box column alignCenter justifyCenter>
      <Spinner size="lg" />
    </Box>
  )
}
